import script from "./CartPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CartPage.vue?vue&type=script&lang=ts&setup=true"

import "./CartPage.vue?vue&type=style&index=0&id=5ac2fbdf&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ac2fbdf"]])

export default __exports__